import { render, staticRenderFns } from "./ThirdPartyPlayers.vue?vue&type=template&id=8d391b3a&scoped=true&"
import script from "./ThirdPartyPlayers.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d391b3a",
  null
  
)

export default component.exports